import { useEffect, useState } from "react";
import { FilterParam, PaginationQuery } from "../types";

export const DEFAULT_DELAY = 300;

export const useDebounce = <T>(value: T, delay: number = DEFAULT_DELAY): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
};

type options = {
  filters?: FilterParam[];
};

export const createLoadOptions = <T>(
  aborterRef: React.MutableRefObject<AbortController | undefined>,
  searchTermRef: React.MutableRefObject<string>,
  get: (query: PaginationQuery, signal: AbortSignal | undefined) => Promise<T[]>,
) => {
  const loadOptions = (inputValue: string, options?: options): Promise<T[]> => {
    aborterRef.current?.abort();
    aborterRef.current = new AbortController();
    searchTermRef.current = inputValue;

    return new Promise<T[]>((resolve, reject) => {
      setTimeout(async () => {
        if (searchTermRef.current == inputValue) {
          try {
            const items = await get(
              {
                filters: options?.filters ?? [],
                limit: 50,
                q: inputValue,
              },
              aborterRef.current?.signal,
            );
            resolve(items ?? []);
          } catch (error) {
            console.error(error);
            reject(error);
          }
        } else {
          reject();
        }
      }, DEFAULT_DELAY);
    });
  };

  return loadOptions;
};
